import type { Entry } from "@schema/catalog.ts";
import styles from "./Poster.module.css";

/**
 * Poster image, if the project has one. `artwork.posterUrl` is fully resolved
 * at build time from the project's `artwork:` policy, so this component knows
 * nothing about where facts come from and never names an image host.
 *
 * A project running `artwork: none` — the default for a new one — renders the
 * fallback everywhere, which is deliberate rather than degraded.
 */
export function Poster({ entry }: { entry: Entry }) {
  if (entry.artwork.posterUrl) {
    return (
      <img
        className={styles.poster}
        src={entry.artwork.posterUrl}
        alt={`Poster for ${entry.title}`}
        loading="lazy"
        width={80}
        height={120}
      />
    );
  }
  const initials = entry.title
    .split(/[\s:—-]+/)
    .filter((word) => /^[A-Za-z0-9]/.test(word))
    .slice(0, 3)
    .map((word) => (word ?? "").charAt(0).toUpperCase())
    .join("");
  return (
    <div className={`${styles.poster} ${styles.fallback}`} role="img" aria-label={entry.title}>
      <span>{initials}</span>
    </div>
  );
}
